import * as React from 'react';
import { FieldComponent } from '../Types/FormSectionBase';
import { shortuid } from 'sos-common/js/utils/guid';

export interface IRefSetterProps {
  fieldRefs: Map<string, React.RefObject<FieldComponent>>;
}

export interface IRefSetterState {}

export class RefSetter extends React.Component<IRefSetterProps, IRefSetterState> {
  constructor(props: IRefSetterProps) {
    super(props);

    this.state = {};
  }

  recursiveCloneChildren = (children: React.ReactNode) => {
    const { fieldRefs } = this.props;

    return React.Children.map(children, (child: React.ReactElement, index) => {
      let childProps = {};
      const ref = fieldRefs.get(child?.props?.fieldName);
      if (ref && child.props && child.props.fieldName) {
        childProps = {
          ...child.props,
          ref,
          key: `${child.props.fieldName}_${index}`,
          children: this.recursiveCloneChildren(child.props.children),
        };
        return React.cloneElement(child, childProps);
      } else if (child?.props) {
        childProps = {
          ...child.props,
          children: this.recursiveCloneChildren(child.props.children),
        };
        return React.cloneElement(child, childProps);
      }
      return child;
    });
  };

  public render() {
    return this.recursiveCloneChildren(this.props.children);
  }
}
